import React, {ReactNode} from 'react';
import {Redirect} from 'react-router-dom';
import {ONBOARDING_PATH} from '@src/paths';

const OnboardingRedirect = ({
  isOnboarding,
  onOnboardingPage,
  children,
}: {
  isOnboarding: boolean;
  onOnboardingPage: boolean;
  children: ReactNode;
}) => {
  if (isOnboarding && !onOnboardingPage) {
    return <Redirect to={ONBOARDING_PATH} />;
  }
  return <>{children}</>;
};

export default OnboardingRedirect;
